export default "__VITE_ASSET__a97a040e__"